// // src/css/ThemeSelector.jsx
// import React, { useState, useEffect } from 'react';
// import { useTheme } from './ThemeContext';
// import './Updatedstyles.css';

// const ThemeSelector = () => {
//   const { theme, updateSidebarColor, updateAccentColor, resetTheme } = useTheme();
//   const [showSelector, setShowSelector] = useState(false);
//   const [sidebarInput, setSidebarInput] = useState(theme.sidebarColor);
//   const [accentInput, setAccentInput] = useState(theme.accentColor);
//   const [errors, setErrors] = useState({ sidebar: '', accent: '' });

//   // Update inputs when theme changes
//   useEffect(() => {
//     setSidebarInput(theme.sidebarColor);
//     setAccentInput(theme.accentColor);
//   }, [theme]);

//   const validateColor = (color) => {
//     // Test if it's a valid CSS color
//     const testElement = document.createElement('div');
//     testElement.style.color = color;
//     return testElement.style.color !== '';
//   };

//   const handleSidebarSubmit = (e) => {
//     e.preventDefault();
//     if (validateColor(sidebarInput)) {
//       updateSidebarColor(sidebarInput);
//       setErrors(prev => ({ ...prev, sidebar: '' }));
//     } else {
//       setErrors(prev => ({ ...prev, sidebar: 'Invalid color format' }));
//     }
//   };

//   const handleAccentSubmit = (e) => {
//     e.preventDefault();
//     if (validateColor(accentInput)) {
//       updateAccentColor(accentInput);
//       setErrors(prev => ({ ...prev, accent: '' }));
//     } else {
//       setErrors(prev => ({ ...prev, accent: 'Invalid color format' }));
//     }
//   };

//   const handleReset = () => {
//     resetTheme();
//     setErrors({ sidebar: '', accent: '' });
//   };

//   // Handle Escape key to close panel
//   useEffect(() => {
//     const handleEscape = (e) => {
//       if (e.key === 'Escape' && showSelector) {
//         setShowSelector(false);
//       }
//     };
    
//     window.addEventListener('keydown', handleEscape);
//     return () => window.removeEventListener('keydown', handleEscape);
//   }, [showSelector]);

//   const handleColorChange = (type, value) => {
//     if (type === 'sidebar') {
//       setSidebarInput(value);
//       if (errors.sidebar) setErrors(prev => ({ ...prev, sidebar: '' }));
//     } else {
//       setAccentInput(value);
//       if (errors.accent) setErrors(prev => ({ ...prev, accent: '' }));
//     }
//   };

//   return (
//     <>
//       {/* Theme Toggle Button */}
//       <button 
//         className="theme-toggle-btn"
//         onClick={() => setShowSelector(true)}
//         title="Customize Theme Colors"
//       >
//         🎨
//       </button>

//       {/* Theme Selector Panel */}
//       {showSelector && (
//         <div className="theme-selector-overlay" onClick={() => setShowSelector(false)}>
//           <div className="theme-selector-panel" onClick={(e) => e.stopPropagation()}>
//             <div className="theme-header">
//               <h3>Customize Theme</h3>
//               <button 
//                 className="close-btn"
//                 onClick={() => setShowSelector(false)}
//                 aria-label="Close"
//               >
//                 ×
//               </button>
//             </div>

//             <div className="theme-controls">
//               {/* Sidebar Color */}
//               <div className="color-control">
//                 <div className="color-preview-row">
//                   <div 
//                     className="color-preview" 
//                     style={{ backgroundColor: theme.sidebarColor }}
//                     aria-label="Current sidebar color"
//                   />
//                   <div>
//                     <div className="color-label">Sidebar Color</div>
//                     <div className="color-value">{theme.sidebarColor}</div>
//                   </div>
//                 </div>
//                 <form onSubmit={handleSidebarSubmit} className="color-input-form">
//                   <input
//                     type="text"
//                     value={sidebarInput}
//                     onChange={(e) => handleColorChange('sidebar', e.target.value)}
//                     placeholder="#191970, rgb(25, 25, 112), midnightblue"
//                     className="color-input"
//                     aria-label="Enter sidebar color"
//                   />
//                   <button type="submit" className="apply-btn">Apply</button>
//                 </form>
//                 {errors.sidebar && <div className="color-error">{errors.sidebar}</div>}
//                 <div className="color-examples">
//                   <small>Examples: #2E8B57, #800080, rgb(46, 139, 87), seagreen</small>
//                 </div>
//               </div>

//               {/* Divider */}
//               <div className="divider" />

//               {/* Accent Color */}
//               <div className="color-control">
//                 <div className="color-preview-row">
//                   <div 
//                     className="color-preview" 
//                     style={{ backgroundColor: theme.accentColor }}
//                     aria-label="Current accent color"
//                   />
//                   <div>
//                     <div className="color-label">Accent Color</div>
//                     <div className="color-value">{theme.accentColor}</div>
//                   </div>
//                 </div>
//                 <form onSubmit={handleAccentSubmit} className="color-input-form">
//                   <input
//                     type="text"
//                     value={accentInput}
//                     onChange={(e) => handleColorChange('accent', e.target.value)}
//                     placeholder="#1e3a8a, rgb(30, 58, 138)"
//                     className="color-input"
//                     aria-label="Enter accent color"
//                   />
//                   <button type="submit" className="apply-btn">Apply</button>
//                 </form>
//                 {errors.accent && <div className="color-error">{errors.accent}</div>}
//                 <div className="color-examples">
//                   <small>Affects: Navbar, Table Headers, Buttons, Highlights</small>
//                 </div>
//               </div>

//               {/* Reset Button */}
//               <div className="theme-actions">
//                 <button onClick={handleReset} className="reset-btn">
//                   Reset to Default
//                 </button>
//                 <button 
//                   onClick={() => setShowSelector(false)}
//                   className="close-panel-btn"
//                 >
//                   Done
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ThemeSelector;










// src/components/ThemeSelector.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from './ThemeContext'; // Fixed path
import './Updatedstyles.css';

const quickColors = [
  '#191970', '#1e3a8a', '#3b82f6', '#10b981',
  '#7e22ce', '#dc2626', '#f59e0b', '#1e293b'
];

const ThemeSelector = () => {
  const {
    theme,
    updateSidebarType,
    updateSidebarSolid,
    updateSidebarGradient,
    updateAppGradient,
    resetTheme,
    generateGradient
  } = useTheme();

  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('sidebar');
  const panelRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target) &&
          !e.target.closest('.theme-toggle-btn')) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentSidebarBg = theme.sidebarType === 'gradient'
    ? generateGradient(theme.sidebarGradient.start, theme.sidebarGradient.end)
    : theme.sidebarColor;

  const currentAppBg = generateGradient(theme.appGradient.start, theme.appGradient.end);

  const handleQuickColorClick = (color) => {
    if (activeTab === 'sidebar') {
      if (theme.sidebarType === 'solid') {
        updateSidebarSolid(color);
      } else {
        // Apply to start color, keep end unless it's same
        updateSidebarGradient(color, theme.sidebarGradient.end === theme.sidebarGradient.start ? color : theme.sidebarGradient.end);
      }
    } else {
      updateAppGradient(color, theme.appGradient.end === theme.appGradient.start ? color : theme.appGradient.end);
    }
  };

  return (
    <>
      {/* Floating Theme Button */}
      <button
        className="theme-toggle-btn"
        onClick={() => setIsOpen(true)}
        aria-label="Open theme customizer"
        title="Customize Theme"
      >
        🎨
      </button>

      {/* Theme Panel */}
      {isOpen && (
        <div className="theme-selector-overlay">
          <div className="theme-selector-panel" ref={panelRef}>
            {/* Header */}
            <div className="panel-header">
              <div>
                <h3>Theme Customizer</h3>
                <p className="subtitle">Personalize your sidebar and application colors</p>
              </div>
              <button className="close-btn" onClick={() => setIsOpen(false)} aria-label="Close">
                ×
              </button>
            </div>

            {/* Tabs */}
            <div className="tabs">
              <button
                className={`tab ${activeTab === 'sidebar' ? 'active' : ''}`}
                onClick={() => setActiveTab('sidebar')}
              >
                Sidebar
              </button>
              <button
                className={`tab ${activeTab === 'application' ? 'active' : ''}`}
                onClick={() => setActiveTab('application')}
              >
                Application
              </button>
            </div>

            <div className="panel-content">
              {/* Sidebar Tab */}
              {activeTab === 'sidebar' && (
                <>
                  <div className="type-toggle">
                    <button
                      className={`type-btn ${theme.sidebarType === 'solid' ? 'active' : ''}`}
                      onClick={() => updateSidebarType('solid')}
                    >
                      Solid
                    </button>
                    <button
                      className={`type-btn ${theme.sidebarType === 'gradient' ? 'active' : ''}`}
                      onClick={() => updateSidebarType('gradient')}
                    >
                      Gradient
                    </button>
                  </div>

                  {theme.sidebarType === 'solid' ? (
                    <div className="color-row">
                      <div className="color-field">
                        <label>Solid Color</label>
                        <div className="color-input-wrapper">
                          <div className="color-preview" style={{ background: theme.sidebarColor }} />
                          <input
                            type="color"
                            className="native-color-input"
                            value={theme.sidebarColor}
                            onChange={(e) => updateSidebarSolid(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="color-row">
                      <div className="color-field">
                        <label>Start Color</label>
                        <div className="color-input-wrapper">
                          <div className="color-preview" style={{ background: theme.sidebarGradient.start }} />
                          <input
                            type="color"
                            className="native-color-input"
                            value={theme.sidebarGradient.start}
                            onChange={(e) => updateSidebarGradient(e.target.value, theme.sidebarGradient.end)}
                          />
                        </div>
                      </div>
                      <div className="color-field">
                        <label>End Color</label>
                        <div className="color-input-wrapper">
                          <div className="color-preview" style={{ background: theme.sidebarGradient.end }} />
                          <input
                            type="color"
                            className="native-color-input"
                            value={theme.sidebarGradient.end}
                            onChange={(e) => updateSidebarGradient(theme.sidebarGradient.start, e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className="gradient-preview"
                    style={{
                      background: currentSidebarBg,
                      height: '120px',
                      borderRadius: '12px',
                      marginTop: '1.5rem',
                      border: '1px solid #e2e8f0'
                    }}
                  />
                </>
              )}

              {/* Application Tab */}
              {activeTab === 'application' && (
                <>
                  <div className="section-title">Application Colors</div>
                  <p style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: '1rem' }}>
                    Controls navbar, buttons, table headers, and accents
                  </p>

                  <div className="color-row">
                    <div className="color-field">
                      <label>Start Color</label>
                      <div className="color-input-wrapper">
                        <div className="color-preview" style={{ background: theme.appGradient.start }} />
                        <input
                          type="color"
                          className="native-color-input"
                          value={theme.appGradient.start}
                          onChange={(e) => updateAppGradient(e.target.value, theme.appGradient.end)}
                        />
                      </div>
                    </div>
                    <div className="color-field">
                      <label>End Color</label>
                      <div className="color-input-wrapper">
                        <div className="color-preview" style={{ background: theme.appGradient.end }} />
                        <input
                          type="color"
                          className="native-color-input"
                          value={theme.appGradient.end}
                          onChange={(e) => updateAppGradient(theme.appGradient.start, e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className="gradient-preview"
                    style={{
                      background: currentAppBg,
                      height: '120px',
                      borderRadius: '12px',
                      marginTop: '1.5rem',
                      border: '1px solid #e2e8f0'
                    }}
                  />
                </>
              )}

              {/* Quick Colors */}
              <div className="section-title">Quick Picks</div>
              <div className="quick-palette">
                {quickColors.map((color) => (
                  <div
                    key={color}
                    className="palette-chip"
                    style={{ background: color }}
                    onClick={() => handleQuickColorClick(color)}
                    title={color}
                  />
                ))}
              </div>

              {/* Footer */}
              <div className="panel-footer">
                <button className="reset-btn" onClick={resetTheme}>
                  Reset to Default
                </button>
                <button className="done-btn" onClick={() => setIsOpen(false)}>
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ThemeSelector;